import styled from 'styled-components';

import Button from '@components/Button/next';

export const Container = styled.div`
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100%;
  z-index: 100000;
  transition: all 0.15s;
  background-color: rgba(0, 0, 0, 0.6);

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const KVKKModalContent = styled.div`
  width: 600px;
  height: 250px;
  z-index: 100000;
  transition: all 0.15s;
  box-shadow: 0px 10px 20px rgba(58, 58, 58, 0.1);
  background-color: ${({ theme }) => theme.palette.white};
  padding: 12px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100vw;
    min-height: 100vh; // needed as a fallback in case -webkit-fill-available is not supported
    min-height: -webkit-fill-available; // needed to prevent scroll on mobile
    right: 0;
    bottom: 0;
    top: 0;
    padding: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 7px;
  height: 24px;
  & span:first-of-type {
    height: 23px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 70px;
    padding: 12px 20px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.lynxWhite};

    & span:first-of-type {
      height: 25px;
    }
  }
`;

export const Main = styled.div`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 16px;
  }
`;

export const Description = styled.div`
  margin-bottom: 10px;
  display: block;
  height: 72px;

  & p {
    line-height: 17.6px;
  }

  & a {
    color: ${({ theme }) => theme.palette.Blue600};
    text-decoration: underline;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: auto;
    max-height: 108px;
    & p {
      line-height: 17.6px;
    }
  }
`;

export const CheckBoxesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 15px;
  }
`;

export const CheckBoxItem = styled.div<{ textHeight: number }>`
  & span {
    font-size: 14px;
    color: ${({ theme }) => theme.palette.D400};
    font-weight: 400;
    margin-left: 3px;
    line-height: 17.6px;
    display: inline-block;
    height: ${({ textHeight }) => textHeight}px;
  }

  & div {
    align-items: flex-start;
    margin-top: 2px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    & span {
      height: auto;
      max-height: auto;
    }
  }
`;

export const Footer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.palette.lynxWhite};
  margin-top: auto;
  display: flex;
  justify-content: center;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 10px;
  }
`;

export const AgreeButton = styled(Button)`
  width: 204px;
  height: 40px;
  align-self: center;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
  }
`;

export const ExtraNote = styled.div`
  & span {
    font-style: italic;
    line-height: 18px;
    display: inline-block;
  }
`;
